exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flexBox__create-module___YHRJj {\n    width: 100%;\n  }\n  \n  .buttonCompanyInfo__create-module___1NoCb {\n      margin-top: 24px;\n  }\n  \n  @media (max-width: 375px) {\n    .flexBox__create-module___YHRJj {\n      min-width: 260px;\n    }\n  }\n  \n  @media (min-width: 769px) {\n    .flexBox__create-module___YHRJj {\n      \n      min-width: 1570px;\n    }\n\n    .flexBoxPage1__create-module___aoN1K {\nmin-width: 870px;\n    }\n  }\n  ", ""]);

// Exports
exports.locals = {
	"flexBox": "flexBox__create-module___YHRJj",
	"buttonCompanyInfo": "buttonCompanyInfo__create-module___1NoCb",
	"flexBoxPage1": "flexBoxPage1__create-module___aoN1K"
};